import * as React from 'react';
import { servicos } from './servicos';
import { inTemporaryStore } from "../../utils/storage.util";

function msToSeconds(ms) {
  return ms / 1000;
}


export const DashboardModel = () => {

  const [filterMode, setFilterMode] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [staticData, setStaticData] = React.useState({});
  const [filters, setFilters] = React.useState({});
  const [order, setOrder] = React.useState({});

  const ordenar = (value) => {
    if (order?.titulo?.[0]) {
      return value.sort((a, b) => a.nome.localeCompare(b.nome));
    }
    return value;
  }

  const filtrar = async (receviedData = staticData) => {
    const keysFilters =
      Object.keys(filters)

        .filter(eachValue => {
          const ob = filters[eachValue];
          return Object.keys(filters[eachValue]).some(k => ob[k]);
        });

    if (keysFilters.length > 0) {
      const filtered = receviedData
        .filter(item => {
          const tmp = {};
          keysFilters.forEach(fk => tmp[fk] = filters[fk]);

          for (var key in keysFilters) {
            const value = keysFilters[key];
            const options = Object.keys(tmp[value])
              .filter(eachValue => tmp[value][eachValue]);

            const included = options.includes(item[value]);
            if (!included) return false;
          }
          return true;
        })

      return filtered;
    }

    return receviedData;
  };

  const updateFilters = (title, index) => {
    const newValue = !filters?.[title]?.[index] ?? true;
    const tmp = {
      ...filters,
      [title]: {
        ...filters[title],
        [index]: newValue
      }
    };
    setFilters(tmp);
  };

  const updateOrder = (title, index) => {
    const newValue = !order?.[title]?.[index] ?? true;
    const tmp = {
      [title]: {
        ...order[title],
        [index]: newValue
      }
    };
    setOrder(tmp);
  }
  
  const checkApiStatus = async (api) => {
  
    const token = inTemporaryStore.getItem('token');
    const requestOptions = {
      method: "GET",
      headers: { "Authorization": `Bearer ${token}`},
      redirect: 'manual'
    };
    
    try {
      const response = await fetch(api.url, api.onlyAuth ? requestOptions : {redirect: 'manual'});
      console.log('response', response);
      return response;
    } catch (e) {
      console.log(`Erro ao checar a api: ${api.nome}`, e);
      throw e
    }
  }
  
 
  const updateCheck = async () => {
    setIsLoading(false);
    try {
      // const apiUrl = await getEnv('REACT_APP_URL_SERVICE');
      const data = servicos;
      const MAX_RESPONSE_TIME = 5000;
      const responses = await Promise.all(
          data.map(async (api) => {
            try {
              const startTimestamp = Date.now();
              const response = await checkApiStatus(api);
              console.log('response', response);
              const endTimestamp = Date.now();
              const responseTime = endTimestamp - startTimestamp;
              if (responseTime > MAX_RESPONSE_TIME) {
                return { ...api, status: 'INSTAVEL', responseTime: msToSeconds(responseTime) };
              } else {
                return { ...api, status: 'OK', responseTime: msToSeconds(responseTime) };
              }
            } catch (e) {
              console.log('e', e);
              console.log('e', e.status);
              return { ...api, status: 'INDISPONIVEL', responseTime: '-' };
            }
          })
      )
      
      const filteredData = await filtrar(responses);
      const orderedData = ordenar(filteredData);
      
      setStaticData(data);
      setData(orderedData);
      setFilterMode(false);
    } catch (error) {
      console.error('Error updating check:', error);
    } finally {
      // setIsLoading(false);
    }
  };
  
  React.useEffect(() => {
    updateCheck();

    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    filters,
    isLoading,
    filterMode,
    setFilterMode,
    data,
    updateCheck,
    updateFilters,
    updateOrder,
    staticData,
    order,
  }
}
